import React, { useContext, useEffect, useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { VoiceCommandContext } from "../VoiceCommand/VoiceContext";

function TreatmentPlan({ recommentation, setRecommentation, suggestiveData }) {
  const [suggTreatment, setSuggTreatment] = useState([]);

  const { treatmentPlanVoice, setTreatmentPlanVoice } =
    useContext(VoiceCommandContext);

  useEffect(() => {
    if (suggestiveData?.diagnosisIcdMasterList)
      setSuggTreatment(suggestiveData?.diagnosisTreatSuggestMasterList);
  }, [suggestiveData?.diagnosisTreatSuggestMasterList]);

  const handleSuggTreatment = (suggVal) => {
    setRecommentation((prevState) =>
      prevState
        ? prevState + "," + suggVal.treatmentSuggestions
        : suggVal.treatmentSuggestions
    );
    setSuggTreatment((prevState) => {
      if (prevState) {
        return prevState.filter((item) => item.id !== suggVal.id);
      }
      return prevState;
    });
  };

  const handleSuggDelete = (suggVal) => {
    setSuggTreatment((prevState) => {
      if (prevState) {
        return prevState.filter((item) => item.id !== suggVal.id);
      }
      return prevState;
    });
  };

  useEffect(() => {
    if (treatmentPlanVoice) {
      const command = treatmentPlanVoice.toLowerCase().trim();

      if (command === "clear treatment plan") {
        setRecommentation("");
      } else {
        setRecommentation((prev) => {
          if (!prev || !prev.endsWith(command)) {
            return prev ? `${prev} ${command}` : command;
          }
          return prev;
        });
      }

      setTreatmentPlanVoice("");
    }
  }, [treatmentPlanVoice]);

  const handleAllSuggTreatment = () => {
    const sug = suggTreatment.map((x) => x.treatmentSuggestions).join(",");
    setRecommentation((prevState) => (prevState ? prevState + "," + sug : sug));
    setSuggTreatment([]);
  };

  return (
    <div className="">
      <div className="h-[270px] overflow-y-scroll">
        <div className="relative w-1/2 mt-5">
          <textarea
            value={recommentation}
            onChange={(e) => setRecommentation(e.target.value)}
            id="Recommendation"
            name="Recommendation"
            rows="3"
            placeholder=" "
            className="peer w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:border-[#189FAA] text-sm font-medium text-[#333] bg-transparent"
          />
          <label
            htmlFor="Recommendation"
            className="absolute left-2 -top-2 text-xs text-gray-500 transition-all peer-placeholder-shown:top-3 peer-placeholder-shown:text-xs peer-placeholder-shown:text-[#959595] peer-focus:-top-2 peer-focus:text-blue-500 peer-focus:text-[10px] bg-white px-1"
          >
            Recommendation
          </label>
        </div>

        <div className="flex flex-wrap gap-1 my-1">
          {suggTreatment &&
            suggTreatment?.map((list) => (
              <div className="flex items-center gap-1 cursor-pointer">
                <div className="p-1 rounded-lg bg-brand-primaryColor text-white text-xs flex items-center gap-1">
                  <p
                    className="m-0.5 p-0.5"
                    onClick={() => handleSuggTreatment(list)}
                  >
                    {list.treatmentSuggestions}
                  </p>
                  <RxCross2
                    onClick={(e) => handleSuggDelete(list)}
                    className="text-xl rounded-[100%] p-1 border border-brand-lightBg"
                  />
                </div>
              </div>
            ))}
          {suggTreatment && suggTreatment.length !== 0 && (
            <div
              className="text-sm underline p-1 text-[#189FAA] text-center cursor-pointer"
              onClick={handleAllSuggTreatment}
            >
              Select All
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default TreatmentPlan;
